import { createBoundedUseStore } from 'common-functions';
import { createStore } from 'zustand/vanilla';

type ScrollTargetId = 'inboundFlightGridSegment';

type ScrollTargetsStoreState = {
  setScrollTarget: (id: ScrollTargetId, element: HTMLElement | null) => void;
  scrollIntoView: (id: ScrollTargetId) => void;
};

type InternalScrollTargetsStoreState = ScrollTargetsStoreState & Partial<Record<ScrollTargetId, HTMLElement>>;

export const ScrollTargetStore = createStore<InternalScrollTargetsStoreState>((set, get) => ({
  setScrollTarget: (id, element) => set({ [id]: element || undefined }),
  scrollIntoView: id => scrollToElementWithOffset(get()[id])
}));

function scrollToElementWithOffset(element: HTMLElement | undefined) {
  if (element) {
    const elementTop = element.getBoundingClientRect().top;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    window.scrollTo({
      top: elementTop + scrollTop - 100,
      behavior: 'smooth'
    });
  }
}

export const useScrollTargetsStore = createBoundedUseStore<ScrollTargetsStoreState>(ScrollTargetStore);
